/* ==========================================================================
   Blinq · FAQs (sections/blinq-faq.liquid): tab switching.
   Click or arrow keys move between tabs; one panel shows at a time.
   ========================================================================== */
(() => {
  const init = (root) => {
    if (!root || root.dataset.bfaqReady) return;
    root.dataset.bfaqReady = 'true';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    if (!tabs.length) return;
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
        else if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
        else if (step) { e.preventDefault(); select(tabs[(i + step + tabs.length) % tabs.length], true); }
      });
    });
  };
  const initAll = (scope) => (scope || document).querySelectorAll('[data-bfaq]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  /* Theme editor: selecting a question block opens its tab */
  document.addEventListener('shopify:block:select', (e) => {
    const panel = e.target.closest('[role="tabpanel"]');
    const root = e.target.closest('[data-bfaq]');
    if (!panel || !root) return;
    const tab = root.querySelector(`[aria-controls="${panel.id}"]`);
    if (tab) tab.click();
  });
})();